// src/environment/environment.js
export const environment = {
  production: true,

  indexApiTopic: "/index-api-topic",
  optionData: "/index-option-data",
  stoackApiTopic: "/stock-api-topic",
  stockDayRangeDataTopic: "/stock-day-range-topic",
  stockDataAnalysisTopic: "/stock-analysis-topic",
  cryptoApiTopic: "/crypto-api-topic/option-data",
  stockSectorTopic: "/stock-sector-topic",
  nseWebsiteOIResposneDataTopic: "/nse-website-oi-response-data-topic",
  sectorIndicestopic: "/sector-indices-topic",
  strategyIndiciesTopic: "/strategy-indices-topic",
  globalMarketDataTopic: "/global-market-data-topic",
  fiiDiiDataTopic: "/fii-dii-data-topic",
  foTopGainerLooserTopic: "/fo-top-gainer-looser-topic",
  blockDealsLargeStockTopic: "/block-deals-large-stock-topic",
  blockDealsTopStockTopic: "/block-deals-top-stock-topic",
  logicalIndicatorValueTopic: "/logical-indicator-value-topic",
  blockDealsTopStockByDate: "/bdlts/get-bdlts-by-date",
  buyerSellerStockTopic: "/buyer-seller-stock-topic",
  stockScannerTopic: "/stock-scanner-topic",
  atlasScannerTopic: "/atlas-scanner-topic",
  positionalStockSignalsUrl: "/positional-stock/signals",
  positionalStockDailyLevelsUrl: "/positional-stock/daily-levels",

  //local hosting
  // baseUrl: "http://localhost:1000",
  // stockApiBaseUrl: "http://localhost:2000",
  // niftyWebsocketUrl: "http://localhost:1000/index-api-ws-data",
  // stockApiDayRangeDataWSUrl: "http://localhost:2000/stock-api-ws",
  // cryptoApiWSUrl: "http://localhost:4000/crypto-api-ws",

  //websocketserverUrl: "http://localhost:3000/ws-crypto-data",
  //  ETHWebsocketUrl: "http://localhost:3000/ETH-ws-crypto-data",
  //  BTCWebsocketUrl: "http://localhost:3000/BTC-ws-crypto-data",


  //production hosting
  baseUrl: 'https://indexapi.noptionwave.com',
  stockApiBaseUrl: 'https://stockapi.noptionwave.com',
  niftyWebsocketUrl: `https://indexapi.noptionwave.com/index-api-ws-data`,
  stockApiDayRangeDataWSUrl: `https://stockapi.noptionwave.com/stock-api-ws`,
  cryptoApiWSUrl: "https://cryptoapi.noptionwave.com/crypto-api-ws",
  
};
